import { ApolloClient, InMemoryCache, NormalizedCacheObject } from "@apollo/client";

export default class GQLClient {
  protected client: ApolloClient<NormalizedCacheObject>

  private static instance = new GQLClient()

  private constructor() {

    // For regular expo usage use :
    //const { serverUrl } = getEnvironment()

    // For web-app env use :
    const serverUrl = "https://admin-oiqia.production.oiqia.net/graphql"
    this.client = new ApolloClient({
      uri: serverUrl,
      cache: new InMemoryCache(),
      queryDeduplication: true,
      defaultOptions: {
        mutate: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      }
    });
  }

  static getIntance() {
    return this.instance;
  }

  public getClient() {
    return this.client;
  }
}